import { useCallback } from 'react';
import { useLocalStorageState } from '@/hooks/useLocalStorageState';

export default function useGlobalModel() {
  // 使用 ahooks 的 useLocalStorageState 管理时区
  const [timezone, setTimezone] = useLocalStorageState('app-timezone', {
    defaultValue: 'Asia/Tokyo',
  });

  // 使用 ahooks 的 useLocalStorageState 管理主题
  const [theme, setTheme] = useLocalStorageState('app-theme', {
    defaultValue: 'light',
  });

  // 主题切换
  const toggleTheme = useCallback(() => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  }, [theme, setTheme]);

  return {
    // 状态
    theme,
    timezone,
    
    // 主题操作
    toggleTheme,
    setTheme,
    
    // 时区操作（由 ahooks 提供）
    setTimezone,
  };
}
